import { useMemo } from 'react';
import { FEATURE_FLAG_CONFIGURATIONS } from './feature-flags';
import type { FeatureFlag } from './types';
import { getSessionValues } from '@/providers/session-provider/get-session-values';

export const isFeatureEnabled = (featureFlag: FeatureFlag) => {
  const customerId = getSessionValues().customerId;
  const configuration = FEATURE_FLAG_CONFIGURATIONS[featureFlag];

  if (!configuration) {
    return true;
  }
  const level = process.env.NEXT_PUBLIC_CLIENT_TYPE as 'local' | 'dev' | 'prod';
  if (configuration[level] === true) {
    if (configuration.overrideDisabledForCustomerIds && customerId) {
      return !configuration.overrideDisabledForCustomerIds.includes(customerId);
    }
    return true;
  }

  if (configuration.overrideEnabledForCustomerIds && customerId) {
    const isEnabledForCustomer =
      configuration.overrideEnabledForCustomerIds.includes(customerId);
    return isEnabledForCustomer;
  }

  return false;
};

export const useFeatureFlag = (featureFlag: FeatureFlag) => {
  const enabled = useMemo(() => {
    return isFeatureEnabled(featureFlag);
  }, [featureFlag]);

  return enabled;
};
